Object.defineProperty(exports, "__esModule", { value: true });
exports.HookError = void 0;
const error_1 = require("../../services/error");
class HookError extends error_1.BaseError {
    constructor(target, fieldName, msg) {
        const fullMsg = `@HookError ${target.name}.${fieldName}: ${msg}`;
        super(fullMsg);
        this.message = fullMsg;
    }
}
exports.HookError = HookError;
//# sourceMappingURL=error.js.map